import { IShoppingCart } from '@/common/interfaces/cart.interface';
import ApiService from '@/services/ApiService';

export default class CartService {
  private apiService: ApiService;

  constructor(apiService: ApiService) {
    this.apiService = apiService;
  }

  public async redeemCoupon(cartId: number, couponCode: string, isPartnerApplication = false): Promise<IShoppingCart> {
    return this.apiService.redeemCoupon({ data: { cartId, code: couponCode, isPartnerApplication } });
  }

  public async removeCoupon(cartContentId: number, isPartnerApplication = false): Promise<IShoppingCart> {
    return this.apiService.removeCoupon({ data: { cartContentId, isPartnerApplication } });
  }
}
